import React, { useContext, useEffect, useState } from 'react'
import { handleRedirectInternal } from '../../../common/components'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import { useFormik } from 'formik'
import { useHistory } from 'react-router-dom'
import authContext from '../../../../product/context/auth/authContext'
import CustomDialog from '../../organisms/Dialog'
import { Button } from '@material-ui/core'
import * as Yup from 'yup'
import { mapData } from '../../../../product/common/components'
import BuynowContext from '../../../../product/context/buynow/buynowContext'
import AlertContext from '../../../../product/context/alert/alertContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import Timer from '@/custom/common/timer'
import { FALLBACK_IMAGE } from '@/utils'

const Makeoffer = (props) => {
    const { user, isAuthenticated } = useContext(authContext)
    const { setAlert } = useContext(AlertContext)
    const { addToMakeOffer, responseStatus } = useContext(BuynowContext)
    const customCommonContext = useContext(CustomCommonContext)

    const { allLocations, configFeatures, allConfigurationVariables } = customCommonContext
    const [product, setProduct] = useState()
    const [productLocation, setProductLocation] = useState({})

    const history = useHistory()

    const [toggleDialog, setToggleDialog] = useState(false)

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    useEffect(() => {
        setProduct(props.data)
    }, [props.data])

    useEffect(() => {
        if (product) {
            formik.setFieldValue('product_id', product.id)
        }
    }, [product])

    const validationArray = Yup.object({
        product_id: Yup.number().required('product id required'),
        qty: Yup.number().min(1).required('Enter quantity'),
        amount: Yup.number().min(1).required('Enter Amount'),
    })

    const formik = useFormik({
        initialValues: { product_id: 0, qty: 0 },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (toggleDialog) {
                if (user.user_id === product.user_id) {
                    setAlert("You can't buy your own product", 'error')
                } else {
                    let cart = []
                    cart.push(values)
                    addToMakeOffer({ cart })
                }
            }
            if (values.qty > 0) setToggleDialog(true)
        },
    })

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'addToMakeoffer') {
                if (responseStatus.status === 'success') {
                    setToggleDialog(false)
                    setTimeout(() => {
                        handleRedirectInternal(history, 'alloffers')
                    }, 2000)
                }
            }
        }
    }, [responseStatus])
    const makeofferQuantity = [
        {
            label: 'Enter Offer Amount',
            name: 'amount',
            type: 'number',
            class: 'col-6',
            size: 'small',
            autoFocus: false,
            formik: formik,
        },
        {
            label: 'Enter Quantity',
            name: 'qty',
            type: 'number',
            placeholder: `${'Max Quantity'} ${product ? product.qty - product.sold : 0}`,
            class: 'col-6',
            size: 'small',
            autoFocus: false,
            formik: formik,
        },
    ]

    useEffect(() => {
        if (product) {
            formik.values.qty = product.qty - product.sold
        }
        if (allLocations?.length) {
            setProductLocation(
                allLocations.filter((item) => item?.id === parseInt(product?.location))[0] || {},
            )
        }
    }, [product])

    return (
        <>
            {product ? (
                <>
                    {product.market_status === 'open' ? (
                        isAuthenticated ? (
                            <PrimaryButton
                                label="Make Offer"
                                type="button"
                                btnSize="small"
                                onClick={() => changeDialogStatus()}
                            />
                        ) : (
                            <></>
                        )
                    ) : null}
                </>
            ) : null}
            <CustomDialog
                title={
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            Make a Offer <img src="/assets/svg/Info.svg" alt="" className="ml-3" />
                        </div>
                        <Button onClick={() => setToggleDialog(false)}>
                            <span className="material-icons">clear</span>
                        </Button>
                    </div>
                }
                open={toggleDialog}
                function={changeDialogStatus}
            >
                <div className="media make-offer-media">
                    <div className="media-left">
                        <img
                            className="cursorDecoy"
                            src={`${global.site_url}/uploads/product/${props.data.avatar}`}
                            onError={(e) => FALLBACK_IMAGE(e)}
                            alt={props.data.title}
                        />
                    </div>
                    <div className="media-body">
                        <h2 className="pv-pro-title">{props.data.title}</h2>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: props.data.desc_proc,
                            }}
                            className="pv-pro-descp"
                        ></div>
                        <div className="gridTimer">
                            <img src="/assets/svg/timer.svg" />
                            <Timer
                                date_added={props.data.date_added}
                                date_closed={props.data.date_closed}
                                withText={1}
                                endText="Time Left: "
                                startText="Starts in: "
                            ></Timer>
                        </div>
                    </div>
                </div>
                <div className="media pickup-media">
                    <img src="/assets/svg/cart-car.svg" alt="" className="media-left mr-3" />
                    <div className="media-body pickup-address">
                        <h6 className="checkoutHead m-0 mb-1">Pick up address</h6>
                        <div>{productLocation?.full_address}</div>
                    </div>
                </div>
                <form onSubmit={formik.handleSubmit}>
                    <div className="biddingCnt beforeLogin">
                        <div className="row">{Object.values(mapData(makeofferQuantity))}</div>
                        <div className="d-flex align-items-center">
                            <PrimaryButton btnSize="small" type="submit" label="Make a Offer" />
                        </div>
                    </div>
                </form>
            </CustomDialog>
        </>
    )
}

export default Makeoffer
